<span ng-show="colheita.loading">
  <i class="fa fa-spinner fa-spin"></i>
</span>
<div ng-hide="colheita.loading" ng-if="colheita.dados">
  <h3><b>Colheita (Todas cultivares)</b></h3>
  <table class="table">
    <tr>
      <td><b>Líquido</b></td>
      <td class="text-right">
        {{colheita.liquido | number:1}} sc/ha
      </td>
    </tr>
    <tr>
      <td><b>Impurezas</b></td>
      <td class="text-right">
        {{colheita.descontos.percentual_impurezas | number:2}}%
      </td>
    </tr>
    <tr>
      <td><b>Umidade</b></td>
      <td class="text-right">
        {{colheita.descontos.percentual_umidade | number:2}}%
      </td>
    </tr>
    <tr>
      <td><b>Período</b></td>
      <td class="text-right">
        {{colheita.data_inicial  | date:'dd/MM'}} a {{colheita.data_final | date:'dd/MM'}}
      </td>
    </tr>
  </table>
</div>
